import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import {
  IUiConfirmationDialogData,
  IUiConfirmationDialogDataInputValidateResult,
  UiConfirmationDialogInputValue,
} from './ui-confirmation-dialog.component.types';

@Component({
  selector: 'lum-ui-confirmation-dialog',
  templateUrl: './ui-confirmation-dialog.component.html',
  styleUrls: ['./ui-confirmation-dialog.component.scss'],
})
export class UiConfirmationDialogComponent {
  errors :IUiConfirmationDialogDataInputValidateResult[] = [];
  isDirty :boolean = false;
  isPristine :boolean = true;
  isTouched :boolean = false;
  isValidating :boolean = false;
  valueBoolean :boolean = false;
  valueString :string = '';

  constructor(
    private _cd :ChangeDetectorRef,
    public dialogRef :MatDialogRef<UiConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data :IUiConfirmationDialogData,
  ) {}

  hasErrors() :boolean {
    return this.errors.length > 0;
  }

  onInputChange(newValue :UiConfirmationDialogInputValue) {
    if (this.isValidating) {
      if (this.#validate()) {
        this.#resetValidation();
      }
    }

    if (this.isPristine) {
      this.isDirty = true;
      this.isPristine = false;
    }
  }
  onInputFocus(e :FocusEvent) {
    this.isTouched = true;
  }

  onNoClick() :void {
    this.dialogRef.close(false); // @TODO: refactor uses to _always_ expect { dismiss :boolean, value ?:UiConfirmationDialogResultValue }
  }

  onYesClick() :void {
    if (!this.#validate()) {
      return;
    }

    const dismiss = false;
    const result = this.data.input?.type
      ? { dismiss, value: this.#getValue() }
      : true; // @TODO: refactor uses to _always_ expect { dismiss :boolean, value ?:UiConfirmationDialogResultValue }

    this.dialogRef.close(result);
  }

  #getValue() :UiConfirmationDialogInputValue | void {
    switch (this.data.input?.type) {
      case 'checkbox':
        return this.valueBoolean;
      case 'text':
      case 'textarea':
        return this.valueString;
      default:
        return void 0;
    }
  }

  #resetValidation() {
    this.isValidating = false;
    this.errors = [];

    this._cd.markForCheck();
  }

  #validate() :boolean {
    this.isValidating = true;

    const { input } = this.data;
    const errors = [];

    if (!input) {
      return true;
    } // always valid if there's no input

    const value = this.#getValue();

    errors.push(...(input.validate?.(value) ?? []));

    switch (input?.type) {
      case 'text':
      case 'textarea': {
        if (input.maxLength && (value as string).length > input.maxLength) {
          errors.push({ message: `${input.label} is too long.` });
        }
        break;
      }
      default: {
        break;
      }
    }

    this.errors = errors;

    this._cd.markForCheck();

    return !this.hasErrors();
  }
}
